import React from 'react';
import { motion } from 'framer-motion';
import { FaTooth, FaSmile, FaTeeth, FaStethoscope } from 'react-icons/fa';

const services = [
  {
    icon: <FaTooth className="text-phoenix-gold w-8 h-8" />,
    title: 'General Dentistry',
    description: 'Comprehensive exams and preventive care.',
  },
  {
    icon: <FaSmile className="text-phoenix-gold w-8 h-8" />,
    title: 'Cosmetic Dentistry',
    description: 'Enhance your smile with whitening and veneers.',
  },
  {
    icon: <FaTeeth className="text-phoenix-gold w-8 h-8" />,
    title: 'Orthodontics',
    description: 'Straighten teeth with braces and Invisalign.',
  },
  {
    icon: <FaStethoscope className="text-phoenix-gold w-8 h-8" />,
    title: 'Oral Surgery',
    description: 'Expert surgical procedures for complex needs.',
  },
];

const ServicesPreview = () => {
  return (
    <section className="bg-gradient-to-br from-phoenix-white via-phoenix-beige/30 to-phoenix-white py-24 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-phoenix-gold/10 rounded-full -translate-x-16 -translate-y-16"></div>
      <div className="absolute bottom-0 right-0 w-48 h-48 bg-phoenix-gold/5 rounded-full translate-x-24 translate-y-24"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-phoenix-black mb-4">
            Our <span className="text-phoenix-gold">Services</span>
          </h2>
          <p className="text-lg text-phoenix-gray max-w-2xl mx-auto">
            Comprehensive dental care tailored to your needs, from routine check-ups to advanced treatments
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map(({ icon, title, description }, index) => (
            <motion.div
              key={index}
              whileHover={{
                scale: 1.05,
                boxShadow: '0 20px 40px rgba(212, 175, 55, 0.15)'
              }}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer text-center border border-phoenix-beige/50 backdrop-blur-sm"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              <motion.div
                className="mb-6 flex justify-center"
                whileHover={{ rotate: 5, scale: 1.1 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                {icon}
              </motion.div>
              <h3 className="text-xl font-bold text-phoenix-black mb-3">{title}</h3>
              <p className="text-phoenix-gray leading-relaxed">{description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          viewport={{ once: true }}
        >
          <motion.a
            href="/services"
            className="inline-flex items-center bg-gradient-to-r from-phoenix-gold to-phoenix-gold/80 text-phoenix-white px-10 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl transition-all duration-300"
            whileHover={{
              scale: 1.05,
              boxShadow: '0 25px 50px rgba(212, 175, 55, 0.3)'
            }}
            whileTap={{ scale: 0.95 }}
          >
            View All Services
            <motion.span
              className="ml-2"
              animate={{ x: [0, 5, 0] }}
              transition={{ duration: 1.5, repeat: Infinity }}
            >
              →
            </motion.span>
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesPreview;
